import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { FaRegLightbulb, FaHandsHelping, FaUsers } from "react-icons/fa";

const AboutSection = () => {
  return (
    <AboutContainer id="about">
      <Content>
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <Title>About Us</Title>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
        >
          <Description>
            TERSA is a leading provider of innovative Mechanical, Electrical, and Civil (MEC)
            solutions. Since our establishment, we have been committed to delivering exceptional
            quality, safety, and customer satisfaction in every project we undertake.
          </Description>
          <Description>
            Our team combines technical expertise with a passion for excellence to create solutions
            that transform spaces and empower communities. At TERSA, we don’t just build structures—
            we build trust and long-lasting relationships with our clients.
          </Description>
        </motion.div>
        <CardsContainer>
          <StatCard
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2, ease: "easeOut" }}
          >
            <Icon as={FaRegLightbulb} />
            <StatTitle>Vision</StatTitle>
            <StatText>
              To be the leading provider of innovative MEC solutions, contributing to sustainable
              community development.
            </StatText>
          </StatCard>
          <StatCard
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.4, ease: "easeOut" }}
          >
            <Icon as={FaHandsHelping} />
            <StatTitle>Mission</StatTitle>
            <StatText>
              To design, build, and maintain world-class infrastructure through technical excellence,
              quality, and sustainability.
            </StatText>
          </StatCard>
          <StatCard
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.6, ease: "easeOut" }}
          >
            <Icon as={FaUsers} />
            <StatTitle>Our People</StatTitle>
            <StatText>
              We invest in skilled personnel and cutting-edge technology to deliver outstanding
              results.
            </StatText>
          </StatCard>
        </CardsContainer>
      </Content>
    </AboutContainer>
  );
};

// Styled Components
const AboutContainer = styled.section`
  background-color: #f3f6fb;
  color: #003366;
  padding: 80px 20px;
`;

const Content = styled.div`
  width: 80%;
  margin: auto;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 20px;
  font-weight: bold;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Description = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const CardsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const StatCard = styled(motion.div)`
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 300px;

  &:hover {
    transform: translateY(-10px);
  }
`;

const Icon = styled.div`
  font-size: 3rem;
  color: #ffa500;
  margin-bottom: 20px;
`;

const StatTitle = styled.h4`
  font-size: 1.5rem;
  margin-bottom: 10px;
  color: #003366;
`;

const StatText = styled.p`
  font-size: 1rem;
  color: #003366;
  line-height: 1.5;
`;

export default AboutSection;
